import MenuPromosList from './MenuPromosList';

export default MenuPromosList;
